// extracted by mini-css-extract-plugin
export default {"tooltip":"qp-z","sharingV2":"rp-z","sharingIconsV2":"sp-z","links":"tp-z","link":"up-z","facebookV2":"vp-z","twitterV2":"wp-z","pinterestV2":"xp-z"};